import store from '../../store';
import api from '../../services/api';
import { Creators } from '../ducks/rec_product_similarity';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { createRunningNotification } from '../../utils/notification';
import { captureSentryException } from '../../utils';

export function* getRecProductSimilarity({ filter }) {
  let newFilter = { ...filter };
  let errorMsg = 'Falha ao listar recomendação de produtos por similaridade';

  try {
    if (filter && filter.is_download) {
      errorMsg = 'Falha ao enviar por e-mail';
      newFilter = {
        ...newFilter,
        firebase_notification_key: yield createRunningNotification({ title: filter.product_label })
      };
    }

    yield put(Creators.recProductSimilarityRequest());
    const response = yield call(api.post, 'rec-product-similarity', newFilter);

    if (filter && filter.is_download) {
      yield put(Creators.recProductSimilaritySuccess(store.getState().rec_product_similarity.data));
    } else {
      yield put(Creators.recProductSimilaritySuccess(response.data));
    }

  } catch (err) {
    yield captureSentryException(err, newFilter);
    yield put(Creators.recProductSimilarityError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: errorMsg
    }));
  }
}